module.exports = __webpack_public_path__ + "static/media/view-pass.193fff6a.svg";